import { useRef } from "react";
import { HiOutlineInformationCircle } from "react-icons/hi";
import Tooltip from "../Tooltip";

import './styles.css';

const TextArea = ({
  placeholder,
  label,
  mandatory,
  tooltipText,
  disabled = false,
  value,
  onChange,
  onInput,
  onKeyDown,
  maxLength,
  textAreaStyle,
  containerStyle,
  labelStyle,
}) => {
  const containerClasses = `textarea-container ${containerStyle ? 'custom-container' : ''}`;
  const labelClasses = `textarea-label ${labelStyle ? 'custom-label' : ''}`;
  const textareaClasses = `textarea-input ${textAreaStyle ? 'custom-textarea' : ''}`;

  const textareaRef = useRef(null);

  return (
    <div className={containerClasses} style={containerStyle}>
      <div className="textarea-label-container">
        {label && (
          <label className={labelClasses} style={labelStyle}>
            {mandatory ? label + " * " : label}
          </label>
        )}
        {(tooltipText !== "" && tooltipText !== undefined) && (
          <Tooltip text={tooltipText}>
            <HiOutlineInformationCircle color="#C27AFF" />
          </Tooltip>
        )}
      </div>
      <textarea
        ref={textareaRef}
        placeholder={placeholder}
        className={textareaClasses}
        style={textAreaStyle}
        disabled={disabled}
        value={value || ""}
        onChange={onChange}
        onInput={onInput}
        onKeyDown={onKeyDown}
        maxLength={maxLength}
      />
    </div>
  );
};

export default TextArea;
